import React from "react";
import ReactDOM from 'react-dom/client';
import styled from "styled-components";

import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";

import Login from "@/pages/login/login";
import Main from "@/pages/main";
import {apiConfig, Store, StoreContext} from "@/store";
import {observer} from "mobx-react-lite";
import {ErrorMessage} from "@/containers/error-message";
import {InfoMessage} from "@/containers/info-message";


const Wrapper = styled.div`
  position: relative;
  height: 100%;
`


const App = observer(() => {
    console.log(apiConfig.endpoints.startSession.state);
    return (
        <Wrapper>
            <ErrorMessage/>
            <InfoMessage/>
            <BrowserRouter>
                <Routes>
                    <Route element={<Login/>} path={"/login"}/>
                    <Route element={<Main/>} path={"/*"}/>
                </Routes>
            </BrowserRouter>
        </Wrapper>
    );
})


const root = document.getElementById('root');

if (!root) {
    throw new Error('root not found')
}


const container = ReactDOM.createRoot(root);
container.render(
    <StoreContext.Provider value={new Store()}>
        <App/>
    </StoreContext.Provider>
);

